import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Input extends Component {
  constructor(props) {
    super(props);

    this.value = '';
  }

  dispatchEvent(event) {
    const e = document.createEvent('HTMLEvents');
    e.initEvent(event, true, true);
    this.input.dispatchEvent(e);
  }

  componentDidMount() {
    /**
     * Reason we attach an interval onto the input is because onChange does not fire
     * when someone autofills a form with something like lastpass.
     *
     * So we manually fire off an onChange event when a value changes also we fire an
     * onFocus when the value changes from nothing to something
     */
    this.listener = setInterval(() => {
      if (this.value === this.input.value) {
        return;
      }

      this.dispatchEvent('change');
      if (this.value === '' && this.value !== this.input.value) {
        this.dispatchEvent('focus');
      }
      this.value = this.input.value;
    }, 50);

    if (this.props.initialValue) {
      this.input.value = this.props.initialValue;
    }
  }

  componentWillUnmount() {
    clearInterval(this.listener);
  }

  render() {
    return (
      <input
        id={this.props.value}
        name={this.props.value}
        type={this.props.type ? this.props.type : 'text'}
        onBlur={this.props.onBlur}
        onChange={this.props.onChange}
        onFocus={this.props.onFocus}
        ref={(input) => { this.input = input; }}
      />
    );
  }
}

Input.propTypes = {
  // Props
  type:  PropTypes.string,
  value:  PropTypes.string,
  initialValue:  PropTypes.string,
  // Functions
  onBlur:  PropTypes.func,
  onChange:  PropTypes.func,
  onFocus:  PropTypes.func
};

Input.defaultProps = {
  initialValue: '',
};

export default Input;
